import { Component, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SeoService, Carrier } from '../../shared';
import { CarrierNetworkService } from './carrier-network.service';

@Component({
  selector: 'carrier-network',
  styles: [require('./carrier-network.component.scss'), require('.//../static.scss')],
  template: require('./carrier-network.component.html'),
  providers: [CarrierNetworkService]
})
export class CarrierNetworkComponent implements AfterViewInit {

  constructor(private route: ActivatedRoute, private seo: SeoService, private service: CarrierNetworkService) {
    // Do stuff
  }

  title = 'Carrier List - Linescape';
  description = 'Linescape is the first liner shipping search engine dedicated to ocean container schedules and routes with searches filtered by port, vessel or carrier.';

  loader: boolean = false;
  carriers: Array<Carrier> = new Array<Carrier>();

  ngAfterViewInit() {
    this.seo.set(this.title, this.description);
    this.route.params.subscribe(params => {
      if (params['scroll'] != null && params['scroll'] === 'true') {
        window.scrollTo(0, 0);
      }
    });

    this.loader = true;
    this.service.getCarriers().then((result: Array<Carrier>) => {
      this.loader = false;
      this.carriers = result;
    }).catch((error) => {
      this.loader = false;
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/static/carrier-network/carrier-network.component.ts